import view from './view';
import icons from '../../img/icons.svg';

class paginationView extends view {
  _parentElement = document.querySelector('.pagination');
  _data;

  addHandlerClick(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      const gotoPage = +btn.dataset.goto;
      handler(gotoPage);
    });
  }

  _generateMarkup() {
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );

    if (this._data.page === 1 && numPages > 1) {
      // console.log(numPages);
      return `
      <button data-goto="${
        this._data.page + 1
      }" class="btn--inline pagination__btn--next">
        <span>Page ${this._data.page + 1}</span>
        <svg class="search__icon">
           <use href="${icons}#icon-arrow-right"></use>
        </svg>
      </button>
        `;
    }
    if (this._data.page > 1 && this._data.page < numPages) {
      return `
              <button data-goto="${
                this._data.page - 1
              }" class="btn--inline pagination__btn--prev">
                <svg class="search__icon">
                 <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${this._data.page - 1}</span>
              </button>
              <button data-goto="${
                this._data.page + 1
              }" class="btn--inline pagination__btn--next">
                <span>Page ${this._data.page + 1}</span>
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-right"></use>
                </svg>
              </button>
      `;
    }

    if (this._data.page === numPages && numPages > 1) {
      console.log(numPages);
      return `
      <button data-goto="${
        this._data.page - 1
      }" class="btn--inline pagination__btn--prev">
        <span>Page ${this._data.page - 1}</span>
        <svg class="search__icon">
           <use href="${icons}#icon-arrow-left"></use>
        </svg>
      </button>
        `;
    }

    if (numPages <= 1) return '';
  }
}
export default new paginationView();
